import { render } from "./RoleCreateComponent.vue?vue&type=template&id=11002923"
import script from "./RoleCreateComponent.vue?vue&type=script&lang=js"
export * from "./RoleCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Role/RoleCreateComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "11002923"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('11002923', __exports__)) {
    api.reload('11002923', __exports__)
  }
  
  module.hot.accept("./RoleCreateComponent.vue?vue&type=template&id=11002923", () => {
    api.rerender('11002923', render)
  })

}


export default __exports__